import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
    labels: ['', '', '', '', '', ''],
    datasets: [
        {
            label: '',
            data: [12, 19, 3, 5, 2, 3],

            backgroundColor: [
                'rgba(14, 93, 151, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)'
            ],
            borderColor: [
                'rgba(14, 93, 151, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)',
                'rgba(231, 231, 231, 1)'
            ],
            borderWidth: 1,
        },
    ]
};

const plugins = [{
    beforeDraw: function (chart) {
        var width = chart.width,
            height = chart.height,
            ctx = chart.ctx;
        ctx.restore();
        var fontSize = (height / 250).toFixed(2);
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "top";
        var text = "STEP 1",
            textX = Math.round((width - ctx.measureText(text).width) / 2),
            textY = height / 2;
        ctx.fillText(text, textX, textY);
        ctx.save();
    }
}]

function Donut() {
    return (

        <Doughnut data={data}
            options={{

                responsive: true,
                maintainAspectRatio: true,
                cutout: 170,
                radius: 115,
                plugins: {
                    title: {
                        display: true,
                        text: "Chart"
                    },
                    legend: {
                        display: false
                    }
                }

            }}
            plugins={plugins}
            height={400} width={400}

        />

    );
}

export default Donut;